var React = require('react');

function VimeoClose (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"28","height":"28","fill":"#FFF7F4","key":0}),React.createElement("line",{"x1":"8.07474","y1":"7.92519","x2":"19.7732","y2":"19.6237","stroke":"#121212","key":1}),React.createElement("line",{"x1":"7.92452","y1":"19.6232","x2":"19.623","y2":"7.92471","stroke":"#121212","key":2})]);
}

VimeoClose.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = VimeoClose;

VimeoClose.default = VimeoClose;
